import { ALGOLIA_SERVICE_TOKEN } from './algolia-injection.token';
import { Injectable, inject } from '@angular/core';
import { algoliasearch } from 'algoliasearch';

@Injectable({ providedIn: 'root' })
export class AlgoliaClientService {
  readonly #algoliaParams = inject(ALGOLIA_SERVICE_TOKEN);
  readonly client = algoliasearch(this.#algoliaParams.applicationId, this.#algoliaParams.apiKey);
}
